import React, { Component } from 'react';
import { ajaxWrapper, resolveVariables } from 'functions';

import {
    Wrapper,
    Container,
    Header,
    FormWithChildren,
    PasswordInput,
    If,
    Div,
    Image,
    Span,
    Link,
    Paragraph,
    Alert,
} from 'library';
import Navbar from 'projectLibrary/navbar.js';
import Footer from 'projectLibrary/footer.js';

class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
    }

    callback = (result) => {
        if ('error' in result) {
            this.setState({ error: true });
        } else {
            console.log('Email Sent');
            window.location.href = '/login/';
        }
    };

    render() {
        return (
            <div>
                <Navbar />

                <Container
                    order={'1'}
                    style={{ 'padding-top': '20px' }}
                    min_height={true}
                >
                    <Header text={'Reset Your Password'} />
                    <FormWithChildren
                        submitUrl={
                            resolveVariables(
                                { text: '/users/reset_password/{params.1}/' },
                                window.cmState.getGlobalState(this),
                            )['text']
                        }
                        redirect={this.callback}
                        defaults={{
                            verified_string: new URLSearchParams(
                                window.location.search,
                            ).get('verified'),
                        }}
                    >
                        <PasswordInput
                            name={'password'}
                            required={true}
                            confirm_password={true}
                        />
                    </FormWithChildren>
                    {this.state.error ? (
                        <Alert
                            text={
                                'Invalid reset link detected.  Please make a new request.'
                            }
                            type={'danger'}
                        />
                    ) : null}
                </Container>

                <Footer />
            </div>
        );
    }
}
export default PasswordReset;
